import * as z from "zod";

export const enableChargebacksBilling = {
  name: "enableChargebacksBilling" as const,
  input: z.object({}),
  output: z.object({
    success: z.boolean(),
    confirmationUrl: z.string().optional(),
  }),
};
